import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  tr,
  th,
  td,
  thead,
  Table,
  div,
  tbody,
  Button,
  Alert,
  DropdownButton,
  MenuItem,
  ButtonGroup,
  FormGroup,
  InputGroup,
  FormControl,
  Modal,
  ControlLabel,
  Glyphicon
} from "react-bootstrap";
import { NewBreadcrumb as BreadcrumbComponent } from "../../../components";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createBrowserHistory } from "history";
import { withRouter, Link } from "react-router-dom";
import { Notification } from "../../../components/notifications";
import isEmpty from "lodash.isempty";
import Pagination from "react-paginating";
import "../../../style/react-paginating.css";
import { getPromoList, deletePromo } from "../../../redux/actions/promoActions";
import moment from "moment";
import Dialog from "react-bootstrap-dialog";
import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";
import "../../../style/listPage.scss";
import {aclUtil} from "../../util"

const history = createBrowserHistory();
class PromoList extends Component {
  static contextTypes = {
    router: PropTypes.object
  }
  constructor(props) {
    super(props);
    this.state = {
      menuKey: 'LIST_PROMO_CODE',
      promoListData: [],
      totalRecords: 0,
      limit: 25,
      search: "",
      perPage: 0,
      currentPage: 1,
      pageCount: 0,
      alertMessage: "",
      msgType: "success",
      path: ["Home", "Manage Promo Code List"],
      links: ["home", "promoList"],
      show: false,
      promoCodeSortIcon: "glyphicon glyphicon-sort-by-attributes-alt",
      discountAmountSortIcon: "glyphicon glyphicon-sort-by-attributes-alt",
      descriptionSortIcon: "glyphicon glyphicon-sort-by-attributes-alt",
      direction: "",
      orderBy: "",
      showDialog: false,
      promoid: "",
      show: false
    };
    this.handleSearch = this.handleSearch.bind(this);
    this.confirmDelete = this.confirmDelete.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
  }

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  componentWillMount() {
    this.props.getPromoList({ page: this.state.currentPage,limit: this.state.limit });
  }

  componentWillReceiveProps(nextProps) {
    if(!aclUtil.isPrimaryMenuAccessible(this.state.menuKey)){
      this.context.router.history.push("/restrictedAccess");
    }
    if (this.props.promoList !== nextProps.promoList) {
      if (nextProps.promoList) {
        const setPageCount =
          nextProps.promoList.total / nextProps.promoList.per_page;
        this.setState({
          promoListData: nextProps.promoList.data,
          totalRecords: nextProps.promoList.total,
          perPage: nextProps.promoList.per_page,
          pageCount: setPageCount
        });
      }
    }

    if (this.props.deletedPromo !== nextProps.deletedPromo) {
      if (nextProps.deletedPromo) {
        this.setState({ show: false });
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("success", nextProps.deletedPromo.message);
        this.props.getPromoList({page:this.state.currentPage,limit: this.state.limit});
      }
    }

    if (this.props.error !== nextProps.error) {
      if (nextProps.error) {
        this.setState({ alert: false });
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("warning", nextProps.error);
      }
    }

    if (this.props.message !== nextProps.message) {
      if (nextProps.message) {
        this.setState({
          alertMessage: nextProps.message,
          msgType: nextProps.alertType
        });
      }
    }
  }

  handleSearch(e) {
    this.setState({ [e.target.name]: e.target.value });
    let searchstring = this.state.search.length > 1 ? this.state.search : "";
    const postData = {
      page: "1",
      limit: this.state.limit,
      search: searchstring
    };

    if (this.state.search.length !== 0) {
      this.props.getPromoList(postData);
    } else {
      this.props.getPromoList({ page: this.state.currentPage,limit: this.state.limit });
    }
  }

  handleSort = orderBy => e => {
    e.preventDefault();

    let direction;
    const sortIcon = `${orderBy}SortIcon`;
    if (this.state.direction === "") {
      direction = "ASC";
      this.setState({
        [sortIcon]: "glyphicon glyphicon-sort-by-attributes",
        direction: "ASC",
        orderBy: orderBy
      });
    } else if (this.state.direction === "ASC") {
      direction = "DESC";
      this.setState({
        [sortIcon]: "glyphicon glyphicon-sort-by-attributes-alt",
        direction: "DESC",
        orderBy: orderBy
      });
    } else if (this.state.direction === "DESC") {
      direction = "ASC";
      this.setState({
        [sortIcon]: "glyphicon glyphicon-sort-by-attributes",
        direction: "ASC",
        orderBy: orderBy
      });
    }
    this.props.getPromoList({ orderBy: orderBy, direction: direction, limit: this.state.limit });
  };

  handleDelete = promoID => {
    this.dialog.show({
      body: "Are you sure you want to delete this?",
      actions: [
        Dialog.CancelAction(),
        Dialog.OKAction(() => {
          this.confirmDelete(promoID);
        })
      ]
    });
  };

  handlePageChange = page => {
    this.setState({
      currentPage: page
    });
    if (this.state.direction !== "" && this.state.orderBy !== "") {
      this.props.getPromoList({
        page: page,
        orderBy: this.state.orderBy,
        direction: this.state.direction,
        limit: this.state.limit
      });
    } else if (this.state.search !== "") {
      this.props.getPromoList({ page: page, search: this.state.search,limit: this.state.limit });
    } else {
      const postData = {
        page: page,
        limit: this.state.limit,
        search: this.state.search ? this.state.search : ""
      };
      this.props.getPromoList(postData);
    }
  };

  confirmDelete = promoID => {
    this.props.deletePromo(promoID);
  };

  render() {
    const { path } = this.state;
    const { currentPage, totalRecords, perPage, pageCount } = this.state;
    let promoRow;
    let promoListData = this.state.promoListData
      ? this.state.promoListData
      : [];

    if (!isEmpty(promoListData)) {
      promoRow = promoListData.map((promo, index) => (
        <tr key={promo.promoID}>
          <td>{promo.promoCode}</td>
          <td>{promo.description} </td>
          <td>{promo.discountAmount}</td>
          <td>{promo.available}</td>
          <td>{(promo.startDateTime) ? moment(promo.startDateTime).format("ll") : ""}</td>
          <td>{(promo.endDateTime) ? moment(promo.endDateTime).format("ll") : ""}</td>
          <td>{promo.status}</td>
          <td>
            <ButtonGroup>
                <DropdownButton title="Action" id="bg-nested-dropdown">
                  {aclUtil.checkACL('EDIT_PROMO_CODE') ? (<MenuItem eventKey={Math.random()} onClick={() => this.context.router.history.push(`/addPromo/${promo.promoID}`)}><i className="glyphicon glyphicon-pencil"></i> Edit</MenuItem>):("")}
                  {aclUtil.checkACL('DELETE_PROMO_CODE') ? (<MenuItem eventKey={Math.random()} onClick={this.handleDelete.bind(this, promo.promoID)}><i className="glyphicon glyphicon-trash"></i> Delete</MenuItem>):("")}
                </DropdownButton>
            </ButtonGroup>
          </td>
        </tr>
      ));
    }

    return (
      <div>
        <Dialog
          ref={el => {
            this.dialog = el;
          }}
        />
        <div className="col-lg-12 list-page">
          <div className="row">
            <div className="col-xs-12">
              <BreadcrumbComponent path={this.state.path} links={this.state.links} context={this.context}/>
            </div>
          </div>
          <div className="panel">
            <header className="panel-heading panel-heading-index">
              <div className="row">
                <div className="col-lg-6 col-md-4 col-sm-12">
                  <h4>Promo Code List</h4>
                </div>
                <div className="col-lg-4 col-md-4 col-sm-12">
                  <FormGroup>
                    <InputGroup>
                      <FormControl type="text" name="search" onKeyUp={this.handleSearch} />
                      <InputGroup.Addon>
                        <Glyphicon glyph="glyphicon glyphicon-search" />
                      </InputGroup.Addon>
                    </InputGroup>
                  </FormGroup>
                </div>
                <div className="col-lg-2 col-md-4 col-sm-12">
                  {aclUtil.checkACL('ADD_PROMO_CODE') ? (
                    <Button className="addMerchant"
                      bsSize="small"
                      bsStyle="success"
                      onClick={() => this.context.router.history.push("/addPromo")}
                    >
                      + Add Promo
                    </Button>)
                    : ("")}
                </div>
              </div>
            </header>
            <div className="panel-body">
              {this.state.show &&
                this.state.alertMessage !== "" && (
                  <div className="col-lg-12">
                    <Alert
                      bsStyle={this.state.msgType}
                      onDismiss={this.handleDismiss}
                    >
                      <strong>{this.state.msgType}:</strong>{" "}
                      {this.state.alertMessage}
                    </Alert>
                  </div>
                )}
              <div className="row">
                <div className="col-lg-12">
                  <table className="table table-hover">
                    <thead>
                      <tr>
                        <th onClick={this.handleSort("promoCode")}>
                          Promo Code{" "}
                          <span
                            className={this.state.promoCodeSortIcon}
                            aria-hidden="true"
                          />
                        </th>
                        <th onClick={this.handleSort("description")}>
                          Description{" "}
                          <span
                            className={this.state.descriptionSortIcon}
                            aria-hidden="true"
                          />
                        </th>
                        <th onClick={this.handleSort("discountAmount")}>
                          Amount{" "}
                          <span
                            className={this.state.discountAmountSortIcon}
                            aria-hidden="true"
                          />
                        </th>
                        <th>Available</th>
                        {/* <th>Used</th> */}

                        <th>Start Date </th>
                        <th>End Date</th>
                        <th>Status</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>{promoRow}</tbody>
                  </table>

                  <div className="text-center">
                    <Pagination
                      total={totalRecords}
                      limit={perPage}
                      pageCount={5}
                      currentPage={currentPage}
                    >
                      {({
                        pages,
                        currentPage,
                        hasNextPage,
                        hasPreviousPage,
                        previousPage,
                        nextPage,
                        totalPages,
                        getPageItemProps
                      }) => (
                        <div className="pagination">
                          <button className="btn btn-default"
                            {...getPageItemProps({
                              pageValue: 1,
                              onPageChange: this.handlePageChange
                            })}
                          >
                            first
                          </button>

                          {hasPreviousPage && (
                            <button className="btn btn-default"
                              {...getPageItemProps({
                                pageValue: previousPage,
                                onPageChange: this.handlePageChange
                              })}
                            >
                              {"<"}
                            </button>
                          )}

                          {pages.map(page => {
                            let activePage = null;
                            if (currentPage === page) {
                              activePage = {
                                backgroundColor: "#ccc",
                                color: "#666"
                              };
                            }
                            return (
                              <button className="btn btn-default"
                                key={page}
                                style={activePage}
                                {...getPageItemProps({
                                  pageValue: page,
                                  onPageChange: this.handlePageChange
                                })}
                              >
                                {page}
                              </button>
                            );
                          })}

                          {hasNextPage && (
                            <button className="btn btn-default"
                              {...getPageItemProps({
                                pageValue: nextPage,
                                onPageChange: this.handlePageChange
                              })}
                            >
                              {">"}
                            </button>
                          )}

                          <button className="btn btn-default"
                            {...getPageItemProps({
                              pageValue: totalPages,
                              onPageChange: this.handlePageChange
                            })}
                          >
                            last
                          </button>
                        </div>
                      )}
                    </Pagination>
                  </div>
                </div>
              </div>
              <div className="clearfix" />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  promoList: state.promoReducer.promoList,
  deletedPromo: state.promoReducer.deletedPromo,
  error: state.promoReducer.error,
  alertType: state.alertsReducer.alertType,
  message: state.alertsReducer.message
});

export default withRouter(connect(mapStateToProps, {
  getPromoList,
  deletePromo,
  renderAlert,
  clearAlert
})(PromoList));



// WEBPACK FOOTER //
// ./src/app/views/admin/promoCode/PromoList.js